import { Info } from "lucide-react";

import type { WholesaleProgress } from "@/services/pricing/pricing-service";

export interface CartWholesaleNoticeProps {
  readonly itemCount: number;
  readonly progress: WholesaleProgress | null;
}

export function CartWholesaleNotice({
  itemCount,
  progress,
}: Readonly<CartWholesaleNoticeProps>) {
  if (!progress) {
    return null;
  }

  const message = itemCount === 0
    ? "Compra 10 unidades o más para acceder a precios por mayor."
    : progress.kind === "product_minimum" && progress.productName
      ? `Agrega ${formatUnits(progress.missingQuantity)} más de ${progress.productName} para precios por mayor.`
      : `Te faltan ${formatUnits(progress.missingQuantity)} para precios por mayor.`;

  return (
    <section
      aria-live="polite"
      className="flex items-center gap-2.5 rounded-xl border border-secondary/30 bg-secondary/10 p-3.5 text-sm font-bold leading-5 text-secondary"
    >
      <Info aria-hidden="true" className="h-5 w-5 shrink-0 text-secondary" />
      <span>{message}</span>
    </section>
  );
}

function formatUnits(quantity: number): string {
  return `${quantity} ${quantity === 1 ? "unidad" : "unidades"}`;
}
